import { ChevronRight } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import { StyleObj, Tournament } from '../../../../@types';
import { getDisplayName } from '../../../../utils';
import SportsIcon from '../../../atoms/SportsIcon';

type TopOfferItemProps = {
  tournament: Tournament;
};

const styles: StyleObj = {
  container: (theme) => ({
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    backgroundColor: 'neutral.600',
    borderBottom: `1px solid ${theme.palette.neutral[500]}`,
    py: { xs: 1, md: 2 },
    pl: { xs: 1.5, md: 2 },
    pr: { xs: 0.5, md: 2 },
  }),
  tournamentName: {
    color: 'neutral.100',
    typography: {
      xs: 'body2',
      md: 'body1',
    },
  },
  icon: {
    color: 'neutral.300',

    fontSize: {
      xs: 20,
      md: 24,
    },
  },
};

const TopOfferItem = ({ tournament }: TopOfferItemProps) => {
  return (
    <Box sx={styles.container}>
      <Stack
        direction='row'
        spacing={1}
        sx={{
          alignItems: 'center',
        }}
      >
        <SportsIcon name={tournament.sport?.icon ?? 'soccer'} size={12} />
        <Typography sx={styles.tournamentName}>{getDisplayName(tournament)}</Typography>
      </Stack>
      <ChevronRight sx={styles.icon} />
    </Box>
  );
};

export default TopOfferItem;
